export default "__VITE_ASSET__82052d45__"